import React, { PureComponent } from "react";
import ButtonField from "../form/ButtonField";
import CheckboxField from "../form/CheckboxField";
import ContentField from "../form/ContentField";
import SelectField from "../form/SelectField";
import StatusField from "../form/StatusField";
import SwitchField from "../form/SwitchField";
import TextField from "../form/TextField";

const PropertyFieldComponentMap = {
  button: ButtonField,
  switch: SwitchField,
  content: ContentField,
  select: SelectField,
  checkbox: CheckboxField,
  colorpicker: TextField,
  radio: TextField,
  status: StatusField
};

export function AddPropertyFieldComponent(key, component) {
  PropertyFieldComponentMap[key] = component;
}

class PropertyField extends PureComponent {
  render = () => {
    const { editor, get, set, hidden, ...props } = this.props;
    if (editor !== undefined && typeof editor !== "string") {
      const Editor = editor;
      return <Editor {...props} />;
    }

    const FieldComponent = PropertyFieldComponentMap[editor] || TextField;
    return <FieldComponent {...props} />;
  };
}

export default PropertyField;
